// extracted by mini-css-extract-plugin
module.exports = {"page":"bC-z","cartModal":"cC-z","checkout":"dC-z","placeholder":"eC-z","account":"fC-z"};